import React, { useState } from "react";
import { Modal, Form, Input, Button, message, Select } from "antd";
import { Col, Row } from "react-bootstrap";
import { EyeInvisibleOutlined, EyeInvisibleTwoTone, EyeTwoTone } from "@ant-design/icons";
import { signupMerchantAdmin } from "../services/merchentApi";
import { useQuery } from "react-query";
import { getAllCountry } from "../../business/services/developerApi";
const CreateNewMerchentModal = ({ visible, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
   const { data: countriesList, isLoading: isLoadingCountry } = useQuery("countriesList", getAllCountry);
   const countryFlags = {
  SN: "https://flagcdn.com/w40/sn.png", // Sénégal
  CI: "https://flagcdn.com/w40/ci.png", // Côte d'Ivoire
  BF: "https://flagcdn.com/w40/bf.png", // Burkina Faso
  BJ: "https://flagcdn.com/w40/bj.png", // Bénin
  NE: "https://flagcdn.com/w40/ne.png", // Niger
  ML: "https://flagcdn.com/w40/ml.png", // Mali
  GN: "https://flagcdn.com/w40/gn.png", // Guinée
  TG: "https://flagcdn.com/w40/tg.png", // Togo
  CM: "https://flagcdn.com/w40/cm.png", // Cameroun
  CD: "https://flagcdn.com/w40/cd.png" , // RDC
  KE: "https://flagcdn.com/w40/ke.png", // KE
  NG: "https://flagcdn.com/w40/ng.png",  // ng
  GH: "https://flagcdn.com/w40/gh.png"//gh
};
 const handleOk = async () => {
  try {
    setLoading(true);
    const values = await form.validateFields();
    const response = await signupMerchantAdmin(values);
    message.success("Marchand créé avec succès ! 🎉");
    form.resetFields();
    onClose();
  } catch (err) {
  console.log(err.response?.data);
  message.error(JSON.stringify(err.response?.data));
} finally {
    setLoading(false);
  }
};
  return (
    <Modal
  title="Créer un marchand"
  open={visible}
  onCancel={onClose}
    footer={[
      <Button key="cancel" onClick={onClose}>Annuler</Button>,
      <Button key="submit"type="primary"loading={loading}onClick={handleOk}>Créer</Button>
      ]}>
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}> 
          <Form.Item
          label="Nom"
          name="lastName"
          rules={[{ required: true, message: "Veuillez entrer le nom" }]}>
            <Input placeholder="Nom" />
          </Form.Item>
          </Col>
          <Col span={12}>
          <Form.Item
          label="Prénom"
          name="firstName"
          rules={[{ required: true, message: "Veuillez entrer le prénom" }]}>
          <Input placeholder="Prénom" />
        </Form.Item>
        </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
          <Form.Item
          label="Email"
          name="email"
          rules={[
          { required: true, message: "Veuillez entrer l'email" },
          { type: "email", message: "Email invalide" }]}>
          <Input placeholder="exemple@mail.com" />
        </Form.Item>
        </Col>
        <Col span={12}>
        <Form.Item
          label="Téléphone"
          name="phoneNumber"
          rules={[{ required: true, message: "Veuillez entrer le téléphone" }]}
        >
          <Input placeholder="+xx xxx xx xx" />
        </Form.Item>
        </Col>
        </Row>
         <Row gutter={16}>
          <Col span={12}>
          <Form.Item
          label="Adresse"
          name="adresse"
          rules={[
          { required: true, message: "Veuillez entrer l'adresse" },
          { type: "adresse", message: "Veuillez entrer l'adresse" }]}>
          <Input placeholder="Dakar" />
        </Form.Item>
        </Col>
        <Col span={12}>
     <Form.Item
      label="Pays"
      name="country"
      rules={[{ required: true, message: "Veuillez sélectionner un pays" }]}
    >
      <Select
        placeholder="Sélectionner un pays"
        loading={isLoadingCountry}
        showSearch
        optionFilterProp="label"
      >
        {countriesList?.map((country) => (
          <Select.Option
            key={country.name}
            value={country.name}      
            label={country.name} 
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <img
                src={countryFlags[country.countryCode.toUpperCase()]}
                alt={country.code}
                style={{ width: "20px", height: "15px", objectFit: "cover" }}
              />
              <span>{country.name}</span>
            </div>
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
        </Col>
        </Row>
         <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Mot de passe"
              name="password"
              rules={[
                { required: true, message: "Veuillez entrer le mot de passe" },
                { min: 6, message: "Minimum 6 caractères" },
              ]}
            >
              <Input.Password
                placeholder="Mot de passe"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
          </Col>
        <Col span={12}>
            <Form.Item
              label="Confirmer le mot de passe"
              name="confirmPassword"
              dependencies={["password"]}
              rules={[
                { required: true, message: "Veuillez confirmer le mot de passe" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Les mots de passe ne correspondent pas")
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                placeholder="Confirmer le mot de passe"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
export default CreateNewMerchentModal;
